import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import injection from "./injection";


export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: injection,
      },
    }),
});
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch